const OPEN_PRODUCT_PAGE = 'OPEN_PRODUCT_PAGE';
const CLOSE_PRODUCT_PAGE = 'CLOSE_PRODUCT_PAGE';

export default {
  OPEN_PRODUCT_PAGE,
  CLOSE_PRODUCT_PAGE
};
